/* unplugin-vue-components disabled */import { render } from "./admin.vue?vue&type=template&id=77a289a7&scoped=true"
import script from "./admin.vue?vue&type=script&setup=true&lang=js"
export * from "./admin.vue?vue&type=script&setup=true&lang=js"

import "./admin.vue?vue&type=style&index=0&id=77a289a7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a289a7"],['__file',"src/pages/settings/admin/admin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77a289a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77a289a7', __exports__)) {
    api.reload('77a289a7', __exports__)
  }
  
  module.hot.accept("./admin.vue?vue&type=template&id=77a289a7&scoped=true", () => {
    api.rerender('77a289a7', render)
  })

}


export default __exports__